module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Cassandra Clark\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("CASSANDRA CLARK spent her childhood in Yorkshire, which served as an inspiration for "), _c('I', [_vm._v("Hangman Blind")]), _vm._v(", her first novel. She lives in London.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vMft5A/tc-custom/9781429964555.jpg?1731883592442",
      "alt": "This image is the cover for the book Hangman Blind, Abbess Hildegard of Meaux"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hangman Blind, Abbess Hildegard of Meaux\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this historical mystery series debut, a medieval English nun investigates the attempted murder of a Yorkshire nobleman.")]), _c('br'), _c('br'), _vm._v("In November 1382, the month of the dead, Abbess Hildegard rides out for York from the Abbey of Meaux. This is no ordinary journey—it is a time of rival popes, a boy king, and a shaky peace in the savage aftermath of Wat Tyler’s murder—and Hildegard has embarked on a perilous mission to try to secure the future of her priory."), _c('br'), _c('br'), _vm._v("Traveling alone, she discovers danger, encountering first a gibbet with five bloodied corpses and then the body of a youth, brutally butchered. Who was the boy, how was he connected to the men hanging from the gibbet, and what do these gruesome deaths mean? Hildegard is determined to uncover the truth, no matter how terrible it may be. When even her childhood home, Castle Hutton, turns out not to be safe from murder, Hildegard realizes she will have to summon all of her courage and wisdom to counter the dark forces that threaten her friends and family as well as her country."), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    John Murray\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0